import {
  Crashlytics,
  CrashlyticsOptions,
  getCrashlytics as getCrashlyticsFirebase,
} from '@firebase/crashlytics';
import { FirebaseApp, initializeApp, getApps, getApp } from '@firebase/app';
// import {
//   initializeAppCheck,
//   ReCaptchaEnterpriseProvider,
// } from '@firebase/app-check';

let app: FirebaseApp | null = null;
let _crashlytics: Crashlytics | undefined;

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: `${process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID}.firebasestorage.app`,
  messagingSenderId: '367739083284',
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: 'G-B33WCQ9MJG',
};

export const crashlyticsOptions: CrashlyticsOptions = {
  endpointUrl: process.env.NEXT_PUBLIC_OTEL_ENDPOINT,
};

export function initFirebase() {
  if (app) {
    return app;
  }

  app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  return app;
}

// export function initAppCheck() {
//   if (!app) initFirebase();

//   if (app && typeof window !== 'undefined') {
//     const siteKey = process.env.NEXT_PUBLIC_FIREBASE_APP_CHECK_KEY;
//     if (siteKey) {
//       initializeAppCheck(app, {
//         provider: new ReCaptchaEnterpriseProvider(siteKey),
//         isTokenAutoRefreshEnabled: true,
//       });
//     } else {
//       console.error(
//         'Missing NEXT_PUBLIC_FIREBASE_APP_CHECK_KEY environment variable.',
//       );
//     }
//   }
// }

export function getCrashlytics(): Crashlytics {
  if (!_crashlytics) {
    _crashlytics = getCrashlyticsFirebase(getApp(), crashlyticsOptions);
  }
  return _crashlytics;
}

export { app };
